/**
 * The personal planner's server state. One eligibility rule lives on the server
 * (`GET /me/tasks*`, `GET /me/calendar`): the home panel, the list and the calendar all read it,
 * so they cannot disagree about which tasks are "mine". Nothing here decides who sees what.
 */
import { useQuery } from '@tanstack/react-query';

import { api, queryKeys } from '@/shared/api';

import type { MyTasksData, MyTasksFilter, MyTasksSummary } from './types';

export function useMyTasksSummary() {
  return useQuery({
    queryKey: queryKeys.myTasks.summary,
    queryFn: ({ signal }) => api.get<MyTasksSummary>('/v1/me/tasks/summary', { signal }),
  });
}

export function useMyTasks(filter: MyTasksFilter) {
  return useQuery({
    queryKey: queryKeys.myTasks.list(filter),
    queryFn: ({ signal }) =>
      api.get<MyTasksData>('/v1/me/tasks', {
        signal,
        query: { q: filter.q.trim() || undefined, status: filter.status },
        repeat: {
          board_id: filter.boardIds,
          workspace_id: filter.workspaceIds,
          bucket: filter.buckets,
          label_id: filter.labelIds,
        },
      }),
    placeholderData: (previous) => previous,
  });
}
